import { Modal, ModalProps } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';

const StyledModal = styled((props) => <Modal {...props} />)`
  div[class*='closeIcon'] {
    display: none;
  }
` as typeof Modal;

/**
 * Blocking modal component that prevents user to close original one with icon or backdrop
 */
export const BlockingModal: React.FC<ModalProps & { children: React.ReactNode }> = (props) => {
  const { children, open, onClose } = props;

  return (
    <StyledModal
      {...props}
      open={open}
      onClose={(event?, reason?) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        onClose();
      }}
    >
      {children}
    </StyledModal>
  );
};
